import { getAppMenus } from '@/api/endpoints';
import { AppMenuDB } from '@/db/repositories';
import { setDBUpdatedNow } from '@/db/helpers/dbMetadata';
import { onlineStatus } from '@/utils';

export const syncAppMenusData = async () => {
  const isOnline = onlineStatus.get();
  if (!isOnline) return;

  try {
    const appMenus = await getAppMenus();
    await AppMenuDB.bulkAdd(appMenus);
    await setDBUpdatedNow('getAppMenus');
  } catch (error) {
    console.error('Failed to sync getAppMenus from API:', error);
    // TODO: Save error to ErrorLogRepo
  }
};

export const getAppMenuData = async () => {
  await syncAppMenusData();

  const appMenus = await AppMenuDB.list();
  return appMenus;
};
